/**
 * Reduce an unknown thrown value to a user-safe display string. The web-common
 * api client throws an {@link import('@worklogix/web-common').ApiError} carrying
 * a non-sensitive `message`; anything else collapses to a generic line so we
 * never surface a raw stack, a PIN, or `[object …]`.
 */
export function toErrorMessage(err: unknown): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return 'Something went wrong. Please try again.';
}
